import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { IconButton } from "../IconButton";
import { CloseIcon } from "../../../icons";

export interface ModalVideoViewerProps {
  video: string;
  autoplay?: boolean;
  onClose: () => void;
}

export const ModalVideoViewer: React.FC<ModalVideoViewerProps> = ({
  video,
  autoplay,
  onClose,
}) => {
  const _video = video?.replace("youtu.be/", "www.youtube.com/watch?v=") || "";

  React.useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEscape);

    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, []);

  return (
    <Box pos={"fixed"} left={0} right={0} top={0} bottom={0} zIndex={"modal"}>
      <Box
        pos={"fixed"}
        left={0}
        right={0}
        top={0}
        bottom={0}
        zIndex={"overlay"}
        bg={"blackAlpha.800"}
        onClick={onClose}
      />

      <Flex
        alignItems={"center"}
        justifyContent={"center"}
        position={"fixed"}
        left={0}
        right={0}
        bottom={0}
        top={0}
        padding={8}
        zIndex={"modal"}
        onClick={onClose}
      >
        <Box pos={"absolute"} right={0} top={0} p={4}>
          <IconButton onClick={onClose} isGhost>
            <CloseIcon color={"text.grey"} boxSize={8} />
          </IconButton>
        </Box>
        {_video && (_video || "").includes("youtube") && (
          <Box
            position="absolute"
            width="80%"
            height="90%"
            maxHeight="calc(100vh - 100px)"
            borderRadius={4}
            as="iframe"
            src={
              _video.replace("/watch?v=", "/embed/") +
              (autoplay ? "?autoplay=1" : "")
            }
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen;"
          />
        )}
        {_video && (_video || "").includes("vimeo") && (
          <Box
            position="absolute"
            width="80%"
            height="90%"
            maxHeight="calc(100vh - 100px)"
            borderRadius={4}
            as="iframe"
            src={
              _video.replace("/vimeo.com", "/player.vimeo.com/video") +
              (autoplay ? "?autoplay=1&loop=1" : "")
            }
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; accelerometer;"
          />
        )}
      </Flex>
    </Box>
  );
};
